import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Gráficas" },
  { label: "Venta Mensual", icon: "fas fa-chart-line", color: "#10b981", bg: "#f0fdf4", href: "/GraficaVentasMensualComparativa", desc: "Venta mensual comparativa", perm: "menu_reportes" },
  { label: "Venta Mensual Vendedor", icon: "fas fa-chart-bar", color: "#3b82f6", bg: "#eff6ff", href: "/GraficaVentasMensualVendedor", desc: "Venta mensual por vendedor", perm: "menu_reportes" },
  { label: "Venta Estado", icon: "fas fa-globe-americas", color: "#f59e0b", bg: "#fffbeb", href: "/GraficaVentasEstado", desc: "Venta por estado", perm: "menu_reportes" },
  { label: "Desgloce Ventas", icon: "fas fa-chart-bar", color: "#8b5cf6", bg: "#f5f3ff", href: "/GraficaVentasDesgloce", desc: "Desglose de ventas", perm: "menu_reportes" },
  { type: "section", label: "Sell thru" },
  { label: "Sell Thru", icon: "fas fa-search-dollar", color: "#0ea5e9", bg: "#f0f9ff", href: "/SellThru", desc: "Sell thru general", perm: "menu_reportes" },
  { label: "Sell Thru Area", icon: "fas fa-search-dollar", color: "#f43f5e", bg: "#fff1f2", href: "/SellThruArea", desc: "Sell thru por área", perm: "menu_reportes" },
  { type: "section", label: "Otros" },
  { label: "Valor Inventario", icon: "fas fa-money-check-alt", color: "#14b8a6", bg: "#f0fdfa", href: "/ValorInventario", desc: "Valor del inventario", perm: "menu_reportes" },
  { label: "Dashboard Ventas Tabla", icon: "fas fa-list", color: "#6366f1", bg: "#eef2ff", href: "/DashboardVentasTabla", desc: "Ventas en tabla", perm: "menu_reportes" },
];

function BotonesReportesVentas() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-chart-line" color="#10b981" bg="#f0fdf4" title="Reportes de Ventas" subtitle="Análisis y gráficas de venta" />
        <div className="row">
          {ITEMS.map((r, i) =>
            r.type === "section"
              ? <MenuSection key={i} title={r.label} />
              : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
          )}
        </div>
      </div>
    </>
  );
}

export default BotonesReportesVentas;
